<template>
  <span v-if="timer" class="fw-bold">{{ timer }}</span>
</template>
<script setup>
import { defineProps, ref, defineEmits, onMounted, watchEffect } from "vue";
import supabase from "@/supabase/config";
import { useStore } from "@/store/index";
const emit = defineEmits(["executeSale"]);
const store = useStore();
const props = defineProps(["tz"]);
const auction = ref({});
const timer = ref(0);
onMounted(() => {
  setTimeout(() => {
    fetchAuction();
  }, 250);

  setTimeout(() => {
    if (auction.value.timer) {
      startCountdown(props.tz);
    }
  }, 1000);
});
const fetchAuction = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction.value = auctions[0];
};
function startCountdown(createdAt) {
  const createdTime = new Date(createdAt).getTime();
  const now = Date.now();
  const elapsedSeconds = Math.floor((now - createdTime) / 1000);
  let remaining = auction.value.timer - elapsedSeconds;

  if (remaining <= 0) {
    timer.value = "sold";
    return;
  }

  timer.value = remaining;

  const interval = setInterval(() => {
    remaining--;
    if (remaining <= 0) {
      clearInterval(interval);
      timer.value = "sold";
      if (!auction.value.blank_timer) {
        emit("executeSale");
      }
    } else {
      timer.value = remaining;
    }
  }, 1000);
}
const haltBidding = async () => {
  //remove bidding buttons from teams 1 second before executing sale

  const { data, error } = await supabase
    .from("auctions")
    .update({ halt_bidding: true })
    .eq("id", store.live_auction)
    .select();
  if (!error) {
    console.log("bids closed succesfully... ");
  }
};
watchEffect(() => {
  console.log(timer.value);
  if (timer.value == 5) {
    haltBidding();
  }
});
</script>
